module.exports = __webpack_public_path__ + "prod/1.42.2/img/plan_ofd2x.c52fa2b8.png";